(function () {
  if (window.__camotecQuickAddInit) return;
  window.__camotecQuickAddInit = true;

window.camotecQA = function(id) {
  let el = document.getElementById(id);
  if (el) return el;
  const tpl = document.querySelector('template[data-qa-tpl="' + id + '"]');
  if (!tpl) return null;
  const frag = tpl.content.cloneNode(true);
  el = frag.getElementById ? frag.getElementById(id) : frag.querySelector('#' + CSS.escape(id));
  tpl.parentNode.insertBefore(frag, tpl);
  tpl.remove();
  el = document.getElementById(id);
  if (el) sortAndFormatVariants(el);
  return el;
};

  window.checkSizesOverflow = function(drawer) {
    if (!drawer) return;
    const container = drawer.querySelector('.js-sizes-container');
    const btn = drawer.querySelector('.js-show-all-sizes');
    if (container && btn) {
      setTimeout(() => {
        const isOverflowing = container.scrollHeight > 50;
        btn.style.display = isOverflowing ? 'block' : 'none';
        btn.onclick = (e) => {
          e.preventDefault();
          const isExpanded = container.classList.toggle('is-expanded');
          btn.textContent = isExpanded ? 'Приховати' : 'Показати всі розміри';
        };
      }, 50);
    }
  };
window.camotecResolveVariant = function(scopeEl, targetInput) {
  if (!scopeEl || !targetInput) return;
  const groups = scopeEl.querySelectorAll('.js-sizes-group');
  if (groups.length <= 1) {
    const one = scopeEl.querySelector('input[type=radio]:checked');
    if (one) targetInput.value = one.value;
    return;
  }
  const pid = scopeEl.getAttribute('data-product-id');
  const map = (window.__camotecBundleMap || {})[pid];
  const parts = ['', '', ''];
  groups.forEach(function(g) {
    const pos = parseInt(g.getAttribute('data-option-position'), 10) || 1;
    const c = g.querySelector('input[type=radio]:checked');
    if (c) parts[pos - 1] = c.getAttribute('data-option-value') || '';
  });
  if (map) {
    const vid = map[parts.join('|')];
    if (vid != null) { targetInput.value = vid; return; }
  }
  const any = scopeEl.querySelector('input[type=radio]:checked');
  if (any) targetInput.value = any.value;
};
  window.closeAllInlinePanels = function() {
    document.querySelectorAll('.inline-variant-panel.is-active, .quick-order-drawer-overlay.is-active').forEach(panel => {
      panel.classList.remove('is-active');
    });

    document.querySelectorAll('li, .product-grid__item, .card-wrapper').forEach(card => {
      if (card.style.zIndex === '99999') {
        card.style.zIndex = '';
        card.style.position = '';
      }
    });

    document.body.style.overflow = '';
  };
function getSdCookie(name) {
  const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return m ? decodeURIComponent(m.pop()) : '';
}
  window.handleQuickOrderSubmit = async function(e, pid) {
    e.preventDefault();
    const form = e.target;

    const bundleWrap = form.querySelector('.quick-order-sizes--bundle');
    if (bundleWrap) {
      const groups = bundleWrap.querySelectorAll('.js-sizes-group');
      const parts = ['', '', ''];
      let allChosen = true;
      groups.forEach(g => {
        const pos = parseInt(g.getAttribute('data-option-position'), 10) || 1;
        const c = g.querySelector('input[type=radio]:checked');
        if (c) parts[pos - 1] = c.getAttribute('data-option-value') || '';
        else allChosen = false;
      });
      if (!allChosen) { alert('Оберіть розмір для кожного елемента комплекту.'); return; }
      const map = (window.__camotecBundleMap || {})[pid] || {};
      const vid = map[parts.join('|')];
      if (!vid) { alert('Такої комбінації розмірів немає в наявності.'); return; }
      form.querySelector('input[name=variant_id]').value = vid;
    }

    const fd = new FormData(form);
    const btn = form.querySelector('.quick-order-submit-btn');
    const originalText = btn.innerText;

    const rawPhone = fd.get('phone');
    const phoneDigitsOnly = rawPhone.replace(/\D/g, '');
    if (phoneDigitsOnly.length < 10) {
      alert('Будь ласка, введіть коректний номер телефону (мінімум 10 цифр).');
      return;
    }

    btn.disabled = true;
    btn.innerText = 'ВІДПРАВКА...';

const payload = {
  variant_id: fd.get('variant_id'),
  phone: rawPhone,
  messenger: fd.get('messenger'),
  shop: window.Shopify.shop,
sd_click_id: getSdCookie('sd_user'),
sd_aid: getSdCookie('sd_aid')
};

    try {
      const WORKER_URL = 'https://camotec-order-handler.camotec.workers.dev/';
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert('Дякуємо! Замовлення прийнято. Менеджер зв\'яжеться з вами найближчим часом.');
        window.closeAllInlinePanels();
      } else {
        const body = await response.text().catch(() => '');
        console.error('QuickOrder server error:', response.status, body);
        alert('Помилка сервера. Спробуйте пізніше або оформіть через кошик.');
      }
    } catch (err) {
      console.error('QuickOrder network error:', err);
      alert('Не вдалося з\'єднатися з сервером. Перевірте інтернет-з\'єднання.');
    } finally {
      btn.disabled = false;
      btn.innerText = originalText;
    }
  };

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => sortAndFormatVariants(document));
} else {
  sortAndFormatVariants(document);
}

function sortAndFormatVariants(root) {
  const panels = (root || document).querySelectorAll('.js-sizes-group, .quick-order-sizes');

  const sizeOrder = [
    'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', 'xxxl', '3xl', 'xxxxl', '4xl',
    'xs-long', 's-long', 'm-long', 'l-long', 'xl-long', '2xl-long', '3xl-long', '4xl-long'
  ];

  panels.forEach(panel => {
    if (panel.querySelector('.js-sizes-group')) return;
    const options = Array.from(panel.children);
    options.sort((a, b) => {
      const textNodeA = a.querySelector('.variant-option__button-label__text') || a;
      const textNodeB = b.querySelector('.variant-option__button-label__text') || b;

      const textA = textNodeA.textContent.trim().toLowerCase();
      const textB = textNodeB.textContent.trim().toLowerCase();

      const indexA = sizeOrder.indexOf(textA);
      const indexB = sizeOrder.indexOf(textB);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      const numA = parseFloat(textA);
      const numB = parseFloat(textB);

      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      return textA.localeCompare(textB);
    });

    options.forEach(option => {
      const textNode = option.querySelector('.variant-option__button-label__text') || option;
      if (textNode.innerHTML.includes('.0')) {
        textNode.innerHTML = textNode.innerHTML.replace(/\.0(?!\d)/g, '');
      }
      panel.appendChild(option);
    });
  });
}

  window.sortAndFormatVariants = sortAndFormatVariants;
})();